import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import ShikhaPhotoGallery from "../Components/Multimedia/PhotoGallery/SikhaPhotoGallery";
import PhotoGalleryAll from "../Components/Multimedia/PhotoGallery/PhotoGalleryYearly/PhotoGalleryHome";

function PhotoGallery() {
  return (
    <>
      <Navbar />
      <ShikhaPhotoGallery />
      <PhotoGalleryAll />
      <Footer />
    </>
  );
}

export default PhotoGallery;
